module.exports = __webpack_public_path__ + "static/media/2.8c7ddc86.png";